/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProjectRefDto } from './projectRefDto';
import { CompanyBrandRefDto } from './companyBrandRefDto';
import { ProjectTaskRefDto } from './projectTaskRefDto';
import { CompanyRefDto } from './companyRefDto';


export interface CreateProjectDto { 
    name: string;
    agency: CompanyRefDto;
    client: CompanyRefDto;
    brand: CompanyBrandRefDto;
    parentId: ProjectRefDto;
    childIds: Array<ProjectRefDto>;
    tasks?: Array<ProjectTaskRefDto>;
    type?: string;
    startDate: string;
    deadline: string;
    parentStartDate?: string;
    parentDeadline?: string;
    description?: string;
    priority?: CreateProjectDto.PriorityEnum;
    clientRefNumber?: string;
    invoiceClient?: CompanyRefDto;
    confidential?: boolean;
    projectNumber?: string;
    validProjectNumber?: boolean;
    status?: string;
    assets?: Array<string>;
    spMakeFoldersKeys?: Array<string>;
    pathToFolderParts?: Array<string>;
}
export namespace CreateProjectDto {
    export type PriorityEnum = 'low' | 'normal' | 'high' | 'urgent';
    export const PriorityEnum = {
        Low: 'low' as PriorityEnum,
        Normal: 'normal' as PriorityEnum,
        High: 'high' as PriorityEnum,
        Urgent: 'urgent' as PriorityEnum
    };
}


